import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

//componentes
import Navbar from './layout/Navbar';
import Footer from './layout/Footer';
import Container from './layout/Container';
import Message from './layout/Message';
import ProtectedRoute from './componentes/protectedroute';

/* pages */
import Home from './pages/Home';
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import Dashboard from './pages/dashboard';
import Planos from './pages/Plans';
import Tutorial from './pages/comoUsar';
import Sobre from './pages/Sobre';
import Privacidade from './pages/Privacidade';
import Termos from './pages/Termos';
import Seguranca from './pages/Seguranca';
import MobileCheckout from './pages/MobileCheckout';

//context
import { UserProvider } from './context/UserContext';

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <Router>
      <UserProvider>
        <Navbar/>
        <Message/>
        <Container>
          <ScrollToHash />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/planos" element={<Planos />} />
            <Route path="/sobre"       element={<Sobre />} />
            <Route path="/privacidade" element={<Privacidade />} />
            <Route path="/termos"      element={<Termos />} />
            <Route path="/seguranca"   element={<Seguranca />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/tutorial" element={<Tutorial />} />
            <Route path="/mobile-checkout" element={<MobileCheckout />} />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
          </Routes>
        </Container>
        <Footer/>
      </UserProvider>
    </Router>
  );
}

export default App;
